import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import moment from 'moment';
import strings from '../strings';
import ErrorActions from './error';
import OrderActions from './order';
import UiActions from './ui';

export default class UploadConfigurationActions {
    static types = actionsFromList([
        // Uploading
        'PRICE_SHEET_UPLOADING',
        'CONFIGURATION_SHEET_UPLOAD_ERROR',
        'CONFIGURATION_SHEET_UPLOAD_PROGRESS',
        'PRICE_SHEET_UPLOAD_SUCCESS',

        'RECEIVED_PRICE_SHEET',
        'REQUESTING_CONFIGURATION_SHEET',
        'CONFIGURATION_SHEET_UPLOADING',
        'SET_DRAG_OVER',
        'SET_UNKOWN_FILETYE',
        'RECEIVED_CONFIGURATION_SHEET_RESPONSE',
        'CONFIGURATION_SHEET_UPLOAD_SUCCESS',
        'SET_ERROR_MESSAGE',
        'CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE',
        'CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE',
        'SUPERMAN',
        'SET_DOWNLOAD_SPINNER'
    ]);

    // sync

    static setErrorMessage = (message) => ({
        type: UploadConfigurationActions.types.SET_ERROR_MESSAGE,
        payload: { message },
    });

    static setExcelUploadErrorResponseData = (message) => ({
        type: UploadConfigurationActions.types
            .CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE,
        payload: { message },
    });

    static clearExcelSheetUploadError = () => ({
        type: UploadConfigurationActions.types
            .CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE,
    });

    static setDragOver = (boolVal) => ({
        type: UploadConfigurationActions.types.SET_DRAG_OVER,
        payload: { boolVal },
    });

    static setUnknownFileType = (boolVal) => ({
        type: UploadConfigurationActions.types.SET_UNKOWN_FILETYE,
        payload: { boolVal },
    });

    static uploadingConfigurationExcelSheet = (file) => ({
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOADING,
        payload: { file },
    });

    static configurationSheetUploadProgress = (total, complete) => ({
        type: UploadConfigurationActions.types
            .CONFIGURATION_SHEET_UPLOAD_PROGRESS,
        payload: { total, complete },
    });

    static excelSheetUploadError = function (error) {
        let data = {
            type: UploadConfigurationActions.types
                .CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE,
            payload: { error },
        };
        return data;
    };

    static receivedConfigurationSheetResponse = (response) => ({
        type: UploadConfigurationActions.types
            .RECEIVED_CONFIGURATION_SHEET_RESPONSE,
        payload: { response },
    });

    static requestingConfigurationSheet = (sheetName) => ({
        type: PricingActions.types.REQUESTING_CONFIGURATION_SHEET,
        payload: { sheetName },
    });

    static configurationSheetUploadSuccess = () => ({
        type: UploadConfigurationActions.types
            .CONFIGURATION_SHEET_UPLOAD_SUCCESS,
    });

    static setDownloadSpinner = (boolVal) => ({
        type: UploadConfigurationActions.types
            .SET_DOWNLOAD_SPINNER,
        payload: (boolVal),
    });

    static uploadConfigurationExcel = (file, offerid) => (dispatch, getState) => {
        const state = getState();
        dispatch(OrderActions.resetExcelProgress());
        dispatch(UploadConfigurationActions.clearExcelSheetUploadError(file));
        dispatch(
            UploadConfigurationActions.uploadingConfigurationExcelSheet(file)
        );
        const timezoneOffset = moment().utcOffset() / 60;        
        state.api
            .uploadConfigurationSheet(file, offerid, timezoneOffset, (total, progress) =>
                dispatch(
                    UploadConfigurationActions.configurationSheetUploadProgress(
                        total,
                        progress
                    )
                )
            )
            .then((result) => {
                // Now convert blob to json data (We are receving the blob instead of
                // json because we are requesting responseType as 'blob' instead of 'application/json'
                // in MapApi.uploadConfigurationSheet, and this because from backend based on the
                // response type(400 or 200) we are sending different data type.
                // For 400 - it is excel blob obj, for 200 it is json. So from UI we stick to only
                // responseType as 'blob' as we cannot request a url with both blob and json)
                if(result.data.type == 'application/vnd.ms-excel'){
                    dispatch(UploadConfigurationActions.excelSheetUploadError(result) );                    
                    dispatch( UploadConfigurationActions.setErrorMessage(strings.uploadError));                    
                    dispatch(UiActions.openModal('failedValidation'));
                    dispatch(UploadConfigurationActions.configurationSheetUploadSuccess());
                }else{
                    const blobObj = result.data;
                    const fileReader = new FileReader();
                    var excelWorkbookData = {};
                    fileReader.onload = (e) => {
                        excelWorkbookData = JSON.parse(e.target.result);
                        dispatch(
                            UploadConfigurationActions.receivedConfigurationSheetResponse(excelWorkbookData)
                        );
                        dispatch(
                            UploadConfigurationActions.configurationSheetUploadSuccess()
                        );
                        dispatch(UiActions.openModal('validation'));
                    };
                    // We need to send blob as input to fileReader
                    fileReader.readAsText(blobObj);
                    return excelWorkbookData;
    
                    // dispatch(
                    //     UploadConfigurationActions.receivedConfigurationSheetResponse(
                    //         excelWorkbookData
                    //     )
                    // );
                    // dispatch(
                    //     UploadConfigurationActions.configurationSheetUploadSuccess()
                    // );
                    // dispatch(UiActions.openModal('validation'));
                }
                
            })
            .catch((error) => {
                dispatch(
                    UploadConfigurationActions.excelSheetUploadError(error)
                );
                dispatch(ErrorActions.catchError(error));
                dispatch(
                    UploadConfigurationActions.setErrorMessage(
                        strings.uploadError
                    )
                );                
                dispatch(UiActions.openModal('failedValidation'));
                dispatch(
                    UploadConfigurationActions.configurationSheetUploadSuccess()
                );
            });
    };
}



// WEBPACK FOOTER //
// ./app/actions/uploadConfiguration.js